import { render, staticRenderFns } from "./indexAll.vue?vue&type=template&id=38c84571&"
import script from "./indexAll.vue?vue&type=script&lang=js&"
export * from "./indexAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports